import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CHeader,
  CToggler,
  CHeaderBrand,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
  CSubheader,
  CBreadcrumbRouter,
  CLink
} from '@coreui/react'

import {
  TheHeaderDropdown,
  TheHeaderDropdownMssg,
  TheHeaderDropdownNotif,
  TheHeaderDropdownTasks
} from './index'

// import { NotificationModel } from '../models'

// const notification_model = new NotificationModel()

const TheHeader = (props) => {
  // const [notifications, setNotifications] = useState([])

  // useEffect(() => {
  // _fetchNotification(99)
  // }, [])

  // const _fetchNotification = async (limit) => {
  //   const notifications = await notification_model.getNotificationBy({
  //     user_code: props._USER.user_code,
  //     notification_seen: '0',
  //     limit: limit
  //   })
  //   setNotifications(notifications)
  // }

  // const _readMore = (limit) => _fetchNotification(limit)

  const dispatch = useDispatch()
  const sidebarShow = useSelector(state => state.sidebarShow)

  const toggleSidebar = () => {
    const val = [true, 'responsive'].includes(sidebarShow) ? false : 'responsive'
    dispatch({ type: 'set', sidebarShow: val })
  }

  const toggleSidebarMobile = () => {
    const val = [false, 'responsive'].includes(sidebarShow) ? true : 'responsive'
    dispatch({ type: 'set', sidebarShow: val })
  }
  
  return (
    <CHeader withSubheader>
      <CToggler inHeader className="ml-md-3 d-lg-none" onClick={toggleSidebarMobile} />
      <CToggler inHeader className="ml-3 d-md-down-none" onClick={toggleSidebar} />
      <CHeaderBrand className="mx-auto d-lg-none" to={`/`} />
      <CHeaderNav className="d-md-down-none mr-auto"></CHeaderNav>
      <div className="align-middle" style={{ marginTop: '20px' }}>
        {'ผู้ใช้งาน  :  ' + props._USER.user_prefix + props._USER.user_name + ' ' + props._USER.user_lastname}&nbsp;{' ( ' + props._USER.user_branch_name + ' )'}
      </div>
      <CHeaderNav className="px-3">
        <TheHeaderDropdownNotif
          user={props._USER}
          notify={props.NOTIFY}
        // onFecthNotification={(limit) => _fetchNotification(limit)}
        // onReadMore={() => _readMore(99)}
        />
        <TheHeaderDropdown />
      </CHeaderNav>
      {/* <CSubheader className="px-3 justify-content-between">
        <CBreadcrumbRouter className="border-0 c-subheader-nav m-0 px-0 px-md-3" routes={routes} />
      </CSubheader> */}
    </CHeader>
  )
}

export default TheHeader